import * as React from "react";

const MyAccount: React.FC = () => {
    return <svg width="27px" height="27px" viewBox="0 0 27 27" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="3.-Style" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="1.Iconography" transform="translate(-501.000000, -293.000000)" fill="currentColor">
            <g transform="translate(79.000000, 230.000000)">
                <g transform="translate(422.000000, 63.000000)" id="UI-Icon/my--account">
                    <path d="M13.499775,0 C6.04414074,0 0,6.04428044 0,13.499865 C0,20.9552696 6.04414074,27 13.499775,27 C20.9554093,27 27,20.9552696 27,13.499865 C27,6.04410044 20.9554093,0 13.499775,0 Z M13.5411994,19.2857143 L13.5411994,19.285533 L13.4590696,19.285533 L7.71428571,19.285533 C7.71428571,15.0383664 11.4040308,15.0393635 12.2228185,13.9288059 L12.3165146,13.4223837 C11.1661591,12.8330232 10.354096,11.4121041 10.354096,9.7502561 C10.354096,7.56086603 11.7628556,5.78571429 13.5002242,5.78571429 C15.2375927,5.78571429 16.6463523,7.56086603 16.6463523,9.7502561 C16.6463523,11.3979638 15.8487246,12.8099999 14.7137013,13.4086966 L14.8203983,13.9841888 C15.7187157,15.0409044 19.2857143,15.1097931 19.2857143,19.2857143 L13.5411994,19.2857143 L13.5411994,19.2857143 Z"></path>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(MyAccount);
